import React from 'react';
import styled from 'styled-components';
import Layout from '../components/Layout';
import PageHero from '../components/PageHero';
import CallToAction from '../components/CallToAction';
import PostCard from '../components/PostCard';
import Button from '../components/ui/Button';
import Container from '../components/ui/Container';
import Reveal from '../components/ui/Reveal';
import Section from '../components/ui/Section';
import { ArrowRight } from '../components/ui/Icons';
import usePageMeta from '../hooks/usePageMeta';
import { BLOG_DESCRIPTION, BLOG_IMAGE, BLOG_IMAGE_ALT, BLOG_TITLE, blogJsonLd, posts } from '../data/blog';

const Grid = styled.ul`
  display: grid;
  gap: clamp(1.25rem, 2.5vw, 2rem);
  grid-template-columns: repeat(3, minmax(0, 1fr));

  @media (max-width: 960px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

const Empty = styled.div`
  max-width: 62ch;
  color: var(--text-2);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.25rem;
`;

const Blog: React.FC = () => {
  usePageMeta({
    title: BLOG_TITLE,
    path: '/blog',
    description: BLOG_DESCRIPTION,
    image: BLOG_IMAGE,
    imageAlt: BLOG_IMAGE_ALT,
    jsonLd: blogJsonLd,
  });

  return (
    <Layout>
      <PageHero eyebrow="Blog" title="Notes from the studio." lead={BLOG_DESCRIPTION} />

      <Section $tone="base" $flushTop>
        <Container>
          <h2 className="visually-hidden" id="all-posts-title">
            All posts
          </h2>
          {posts.length > 0 ? (
            <Grid aria-labelledby="all-posts-title">
              {posts.map((post, index) => (
                <Reveal as="li" key={post.slug} delay={index * 0.05}>
                  <PostCard post={post} priority={index === 0} />
                </Reveal>
              ))}
            </Grid>
          ) : (
            <Empty>
              <p>No posts yet.</p>
              <Button to="/projects" variant="secondary">
                See our work <ArrowRight />
              </Button>
            </Empty>
          )}
        </Container>
      </Section>

      <CallToAction />
    </Layout>
  );
};

export default Blog;
